import apiClient from '../apiClient';
import { GET_RESTAURANT_ITEM_ALL_URL } from '../apiUrl';

const getRestaurantItemAllApi = () => {
  return apiClient.get(GET_RESTAURANT_ITEM_ALL_URL);
};

export default getRestaurantItemAllApi;
